import React, { useMemo } from 'react';
import { Stack, useThemeName } from '@adc/parallax-component-library';
import { useTheme } from '@adc/parallax-component-library';
import { useMediaQuery } from 'Hooks';
import { AppLogo } from 'Components/utility';
const MEDIA_QUERY = { maxWidth: 440 };
const Container = ({ children }) => {
    const [isMobileBrowser] = useMediaQuery(MEDIA_QUERY);
    const theme = useTheme();
    const themeName = useThemeName();
    // @ts-expect-error Typescript complains on `.val` usage
    const color = theme['surface.container'].val;
    const additionalProps = useMemo(() => isMobileBrowser
        ? {
            padding: 16,
        }
        : {
            borderRadius: 32,
            padding: 80,
            paddingTop: 48,
            shadow: '$1',
            maxWidth: 560,
        }, [isMobileBrowser]);
    return (React.createElement(React.Fragment, null,
        isMobileBrowser && (React.createElement("meta", { name: "theme-color", media: `(prefers-color-scheme: ${themeName})`, content: color })),
        React.createElement(Stack, { flexDirection: "column", backgroundColor: isMobileBrowser ? '$surface.container' : '$surface.background', alignItems: "center", style: [
                {
                    minHeight: window.innerHeight,
                    height: '100vh',
                },
            ] },
            React.createElement(AppLogo, { isMobileBrowser: isMobileBrowser }),
            React.createElement(Stack, { ...additionalProps, backgroundColor: "$surface.container", gap: "$8", width: "100%" }, children))));
};
export { Container };
